// Mock data for the Indosbook landing page (frontend-only teaser)
// NOTE: All data here is MOCKED. Backend will replace these later.

export const navLinks = [
  { label: "Communities", to: "/pages/community" },
  { label: "Companies", to: "/pages/careers" },
];

export const heroStat = "9,000+ Indian seafarers, 400+ shipping companies & 110+ DG Shipping-approved institutes";

export const heroTitle = ["One Nation,", "One Maritime Community"];

export const heroSubtitle =
  "Join 9,000+ Indian seafarers, 400+ shipping companies & 110+ DG Shipping-approved institutes and counting.";

export const heroFeatures = [
  {
    id: "f1",
    icon: "Anchor",
    titleBold: "Network & Connect",
    rest: "Instantly chat with fellow sailors, hiring managers, and maritime institutes in one dedicated hub.",
  },
  {
    id: "f2",
    icon: "Map",
    titleBold: "Genuine Jobs",
    rest: "Access hand-picked sea contracts and maritime training courses designed specifically for your rank and experience.",
  },
  {
    id: "f3",
    icon: "Sun",
    titleBold: "Professional Crew Profile",
    rest: "Build a verified online resume that gives shipping companies a trusted view of your complete sea service history and achievements.",
  },
];

export const trustedCompanies = [
  "Maersk Line",
  "MSC",
  "Anglo-Eastern",
  "Synergy Marine",
  "Fleet Management",
  "Wilhelmsen",
];

export const communityStats = [
  { id: "c1", value: "9K+", label: "Active seafarers" },
  { id: "c2", value: "400+", label: "Shipping companies" },
  { id: "c3", value: "110+", label: "Maritime institutes" },
  { id: "c4", value: "1.5K", label: "Job posts / month" },
];

export const featureCards = [
  {
    id: "fc1",
    icon: "Ship",
    title: "Post & find sea jobs",
    desc: "Companies post openings by rank and vessel type; seafarers apply in a tap.",
  },
  {
    id: "fc2",
    icon: "Users",
    title: "Follow companies & institutes",
    desc: "Follow the fleets and academies you love and never miss a sign-on or course.",
  },
  {
    id: "fc3",
    icon: "MessagesSquare",
    title: "Join communities",
    desc: "Talk decks, engine rooms, exams and shore life with crew worldwide.",
  },
  {
    id: "fc4",
    icon: "BadgeCheck",
    title: "Verified profiles",
    desc: "Show your CDC, rank and sea service so recruiters trust your profile.",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Capt. Rohan Mehta",
    role: "Master Mariner",
    quote:
      "Found my last two contracts through Indosbook. The community feels like the messroom, but global.",
  },
  {
    id: "t2",
    name: "Priya Nair",
    role: "Crewing Manager, Synergy",
    quote:
      "We fill deck and engine vacancies faster here than on any traditional crewing portal.",
  },
  {
    id: "t3",
    name: "Dr. Alan Fernandes",
    role: "Principal, Maritime Academy",
    quote:
      "Our institute connects directly with cadets and recruiters here — admissions and placements in one place.",
  },
];


// ===================== FEED MOCK DATA =====================

export const feedTabs = [
  { id: "all", label: "All Feed" },
  { id: "community", label: "Community Posts" },
  { id: "jobs", label: "Maritime Jobs" },
];

// Job posts styled like Reddit posts
export const rankOptions = [
  "Master", "Chief Officer", "2nd Officer", "3rd Officer", "Deck Cadet",
  "Chief Engineer", "2nd Engineer", "3rd Engineer", "4th Engineer", "ETO",
  "Able Seaman", "Ordinary Seaman", "Bosun", "Fitter", "Oiler", "Cook",
];

export const vesselOptions = [
  "Oil Tanker", "Chemical Tanker", "LNG Carrier", "LPG Carrier", "Bulk Carrier",
  "Container", "Car Carrier (PCTC)", "General Cargo", "Passenger / Cruise", "Offshore / OSV",
];


// ===================== LEGAL PAGES =====================
// Original, generic policy copy for the Indosbook platform.

export const legalPages = {
  terms: {
    slug: "terms",
    title: "Terms & Conditions",
    updated: "Last updated: July 2025",
    intro:
      "Welcome to Indosbook. By creating an account or using our platform, you agree to these Terms & Conditions. Indosbook is a community platform for seafarers, shipping companies and maritime institutes.",
    sections: [
      {
        h: "1. Eligibility",
        p: "You must be at least 18 years old and legally able to enter into a contract to use Indosbook. Company and institute accounts must be created by an authorised representative of that organisation.",
      },
      {
        h: "2. Your account",
        p: "You are responsible for keeping your login details secure and for all activity that happens under your account. Provide accurate information about your rank, sea service, organisation or institute and keep it up to date.",
      },
      {
        h: "3. Posting content",
        p: "You are responsible for the job posts, comments and other content you share. Do not post false vacancies, request payment from seafarers for jobs, or share content that is misleading, unlawful or infringes others' rights.",
      },
      {
        h: "4. Jobs & applications",
        p: "Indosbook is a platform that connects seafarers, companies and institutes. We do not employ seafarers and are not a party to any employment contract. We do not guarantee the accuracy of any job post or the outcome of any application.",
      },
      {
        h: "5. Prohibited conduct",
        p: "You agree not to harass other members, scrape data, upload malware, impersonate others, or use the platform for any unlawful purpose. We may suspend or remove accounts that breach these Terms.",
      },
      {
        h: "6. Changes",
        p: "We may update these Terms from time to time. Continued use of Indosbook after changes take effect means you accept the updated Terms.",
      },
    ],
  },
  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    updated: "Last updated: July 2025",
    intro:
      "This Privacy Policy explains what information Indosbook collects, how we use it, and the choices you have. We are committed to protecting the privacy of seafarers, companies and institutes.",
    sections: [
      {
        h: "1. Information we collect",
        p: "We collect the details you provide when you register (such as name, email, rank, sea service, company or institute name), the content you post, and technical data such as device and usage information.",
      },
      {
        h: "2. How we use your information",
        p: "We use your information to run the platform, match seafarers with relevant jobs and courses, personalise your feed, keep the community safe, and communicate important updates.",
      },
      {
        h: "3. Sharing",
        p: "Profile details and posts you share publicly are visible to other members. When you apply to a job, relevant profile information is shared with that company. We do not sell your personal data.",
      },
      {
        h: "4. Data retention",
        p: "We keep your information for as long as your account is active or as needed to provide the service and meet legal obligations. You may request deletion of your account at any time.",
      },
      {
        h: "5. Your rights",
        p: "Depending on your location, you may have the right to access, correct, export or delete your personal data. Contact us to exercise these rights.",
      },
      {
        h: "6. Contact",
        p: "For any privacy questions, reach us at privacy@indosbook.com.",
      },
    ],
  },
  disclaimer: {
    slug: "disclaimer",
    title: "Disclaimer",
    updated: "Last updated: July 2025",
    intro:
      "The information on Indosbook is provided for general community and informational purposes only.",
    sections: [
      {
        h: "1. No guarantees",
        p: "Indosbook does not verify every job post, company or institute. Members should independently verify vacancies, credentials and offers before acting on them, and should never pay money to secure a genuine seafaring job.",
      },
      {
        h: "2. Not professional advice",
        p: "Content shared by members — including exam tips, career guidance and technical discussion — is community opinion and not a substitute for official regulations, flag-state guidance or professional advice.",
      },
      {
        h: "3. Third-party links",
        p: "Our platform may contain links to third-party websites. We are not responsible for the content, policies or practices of those sites.",
      },
      {
        h: "4. Limitation of liability",
        p: "To the extent permitted by law, Indosbook is not liable for any loss arising from your use of the platform or reliance on any content posted by members.",
      },
    ],
  },
  cookies: {
    slug: "cookies",
    title: "Cookie Policy",
    updated: "Last updated: July 2025",
    intro:
      "This Cookie Policy explains how Indosbook uses cookies and similar technologies to recognise you when you visit the platform.",
    sections: [
      {
        h: "1. What are cookies",
        p: "Cookies are small text files stored on your device that help websites work and remember your preferences, such as staying logged in.",
      },
      {
        h: "2. How we use cookies",
        p: "We use essential cookies to keep you signed in and secure, preference cookies to remember your settings (like feed sort order), and analytics cookies to understand how the platform is used.",
      },
      {
        h: "3. Managing cookies",
        p: "You can control and delete cookies through your browser settings. Blocking essential cookies may affect how parts of Indosbook work.",
      },
      {
        h: "4. Updates",
        p: "We may update this Cookie Policy as our use of cookies changes. Please check back for the latest version.",
      },
    ],
  },
  refund: {
    slug: "refund",
    title: "Refund Policy",
    updated: "Last updated: July 2025",
    intro:
      "This Refund Policy explains how Indosbook handles payments, cancellations and refunds for any paid features or subscriptions on the platform.",
    sections: [
      {
        h: "1. Free and paid features",
        p: "Indosbook is free for seafarers to join, browse jobs and apply. Some features for companies and institutes — such as featured job posts or subscriptions — may be paid. Paid plans clearly show the price and billing period before you confirm.",
      },
      {
        h: "2. Cancellations",
        p: "You can cancel a paid subscription at any time from your account settings. Cancellation takes effect at the end of your current billing period, and you keep access to paid features until then.",
      },
      {
        h: "3. Refunds",
        p: "If you are charged in error or a paid feature was not delivered as described, contact us within 14 days of the charge at billing@indosbook.com with your account email and transaction details. Approved refunds are returned to your original payment method within 7–10 business days.",
      },
      {
        h: "4. Non-refundable items",
        p: "Payments for services already used — such as a featured job post that has been published — and partial billing periods are generally non-refundable, except where required by law.",
      },
      {
        h: "5. No payment for seafaring jobs",
        p: "Seafarers are never asked to pay to view or apply for a job on Indosbook. If anyone asks you to pay for a job, do not pay and report it to support@indosbook.com immediately.",
      },
      {
        h: "6. Contact",
        p: "For any billing or refund question, write to billing@indosbook.com and our team will respond within 2 business days.",
      },
    ],
  },
};

export const footerLegalLinks = [
  { label: "Terms & Conditions", to: "/legal/terms" },
  { label: "Privacy Policy", to: "/legal/privacy" },
  { label: "Disclaimer", to: "/legal/disclaimer" },
  { label: "Cookie Policy", to: "/legal/cookies" },
  { label: "Refund Policy", to: "/legal/refund" },
];


// ===================== CONTENT PAGES =====================
// Elegant multi-section pages grouped by footer header.
// Each footer link becomes a section on its group's page.

export const contentPages = {
  community: {
    slug: "community",
    seoTitle: "Seafarer Community & Maritime Forums | Indosbook",
    seoDescription:
      "Join the Indosbook seafarer community — maritime forums by rank and vessel type, community guidelines and real stories from the global merchant navy crew.",
    eyebrow: "Community",
    title: "Where the global crew comes together",
    subtitle:
      "Indosbook is one big community of seafarers, shipping companies and maritime institutes — split into focused spaces so the right conversation always finds you.",
    sections: [
      {
        id: "communities",
        icon: "Users",
        heading: "Communities",
        intro:
          "Join spaces built around your rank, your vessel type and the topics you care about. Ask questions, share sea stories, and stay in the loop on everything happening at sea.",
        cards: [
          { title: "By rank", desc: "Deck officers, engineers, cadets, ratings — find your peers and talk shop." },
          { title: "By vessel", desc: "Tankers, bulk carriers, container, LNG, offshore — deep-dive with people who sail them." },
          { title: "By topic", desc: "Exams, endorsements, shore leave, mental health, contracts and pay." },
        ],
      },
      {
        id: "guidelines",
        icon: "ShieldCheck",
        heading: "Community Guidelines",
        intro:
          "A good messroom runs on respect. These simple rules keep Indosbook safe, useful and welcoming for every member.",
        list: [
          "Be respectful. Treat every member — junior or senior, ship or shore — with courtesy.",
          "No fake vacancies. Only post genuine jobs with accurate rank, vessel and terms.",
          "Never ask a seafarer to pay for a job. Charging crew for employment is strictly banned.",
          "Keep it professional. No harassment, hate speech, or personal attacks.",
          "Protect privacy. Don't share anyone's documents or personal details without consent.",
          "Stay on topic. Post in the community that fits your content so others can find it.",
        ],
      },
      {
        id: "blog",
        icon: "Newspaper",
        heading: "From the Feed",
        intro:
          "Guides, career tips and stories from life at sea — written with and for the merchant navy community.",
        posts: [
          { tag: "Careers", date: "Jul 2025", title: "How to stand out when applying for your next contract", excerpt: "Small tweaks to your profile and sea service that get recruiters to notice you first." },
          { tag: "Exams", date: "Jun 2025", title: "A cadet's guide to clearing competency orals", excerpt: "What examiners really look for, and how to prepare without burning out." },
          { tag: "Life at sea", date: "Jun 2025", title: "Staying connected with family on long voyages", excerpt: "Practical tips on wifi, routines and mental well-being during a tour." },
        ],
      },
    ],
  },

  careers: {
    slug: "careers",
    seoTitle: "Shipping Companies & Merchant Navy Careers | Indosbook",
    seoDescription:
      "Shipping companies and manning agencies hire seafarers on Indosbook. Post vacancies, manage applicants and find officers, engineers and ratings by rank and vessel type.",
    eyebrow: "Careers",
    title: "Find your next sign-on — or your next great hire",
    subtitle:
      "Whether you're a seafarer looking for the right berth or a company searching for reliable crew, Indosbook brings both sides together in one honest place.",
    sections: [
      {
        id: "companies",
        icon: "Building2",
        heading: "Companies",
        intro:
          "Every shipping company gets a home on Indosbook — a verified profile where seafarers can follow you, explore your fleet and never miss an opportunity.",
        features: [
          "Verified company badge builds trust with crew",
          "A public profile showcasing your fleet and culture",
          "Followers get notified about every new vacancy",
          "Direct, honest connection with the crew you need",
        ],
      },
      {
        id: "find-jobs",
        icon: "Search",
        heading: "Find Jobs",
        intro:
          "Browse thousands of verified openings, filter by rank and vessel type, and apply in a single tap — no agents, no middlemen.",
        features: [
          "Filter by rank, vessel type, joining date and trading area",
          "See wages, contract length and joining details up front",
          "Apply directly and track your applications",
          "Follow companies to get alerts the moment they post",
        ],
      },
      {
        id: "post-a-job",
        icon: "Briefcase",
        heading: "Post a Job",
        intro:
          "Reach active, qualified seafarers directly. Post a vacancy in minutes and let the right crew come to you.",
        features: [
          "Create a job post with rank, vessel and terms in under two minutes",
          "Reach a focused audience of verified seafarers",
          "Manage applications from one simple dashboard",
          "Build a following so your next opening reaches crew instantly",
        ],
      },
    ],
  },

  institutes: {
    slug: "institutes",
    seoTitle: "Maritime Institutes, STCW Courses & Admissions | Indosbook",
    seoDescription:
      "DG-approved maritime institutes list STCW courses, pre-sea training and admissions on Indosbook, and connect directly with cadets and serving seafarers.",
    eyebrow: "For Maritime Institutes",
    title: "Bring your academy online, connect with future crew",
    subtitle:
      "Maritime institutes are a core part of the Indosbook community. Showcase your courses, manage admissions and stay connected with cadets and alumni across their entire career.",
    sections: [
      {
        id: "courses",
        icon: "BookOpen",
        heading: "Courses",
        intro:
          "List your pre-sea, competency and refresher courses so aspiring and serving seafarers can discover exactly what they need to sail and to progress.",
        cards: [
          { title: "Pre-sea training", desc: "GP Rating, DNS, ETO and cadet programmes for newcomers." },
          { title: "Competency (CoC)", desc: "Prep courses for deck and engine competency examinations." },
          { title: "STCW & refresher", desc: "Mandatory modular and value-added courses, kept up to date." },
        ],
      },
      {
        id: "admissions",
        icon: "GraduationCap",
        heading: "Admissions",
        intro:
          "Run admissions right where your future students already are. Share intakes, answer questions and guide candidates from enquiry to enrolment.",
        features: [
          "Publish batch dates, eligibility and fees clearly",
          "Answer aspirant questions in a dedicated community",
          "Highlight placement records and alumni success",
          "Stay connected with cadets long after they graduate",
        ],
      },
      {
        id: "partner",
        icon: "Handshake",
        heading: "Partner With Us",
        intro:
          "Join a growing network of maritime academies on Indosbook. Get a verified institute profile and a direct line to seafarers, cadets and shipping companies alike.",
        features: [
          "Verified institute badge and public profile",
          "Reach seafarers, cadets and recruiters in one place",
          "Feature courses and admissions to a focused audience",
          "Grow your alumni community and its lifelong value",
        ],
      },
    ],
  },

  help: {
    slug: "help",
    seoTitle: "Help & Support | Indosbook",
    seoDescription:
      "Get help with your Indosbook account, PIN login, jobs, courses and institutes. Contact help@indosbook.com or support@indosbook.com — we reply to every genuine query.",
    eyebrow: "Help & Support",
    title: "We're here to help you sail smoothly",
    subtitle:
      "Whether it's your account, a job, a course, or something that doesn't look right — the Indosbook team is here. Reach out any time.",
    sections: [
      {
        id: "help",
        icon: "LifeBuoy",
        heading: "Help Center — Your Account",
        intro:
          "Everything about signing in and managing your Indosbook account. Browse the guides below, or write to us at help@indosbook.com.",
        contactEmail: "help@indosbook.com",
        contactNote: "For account access, login and password help",
        cards: [
          { title: "How to log in", desc: "Go to the Log in page and sign in with your email and password, or choose Continue with Google. Keep your login details private." },
          { title: "Reset your password", desc: "On the login page, click 'Forgot password', enter your email, and we'll send a temporary password. You'll be asked to set a new one after signing in." },
          { title: "Change your password", desc: "Signed in already? Go to your account settings to set a new password. Make sure your new and confirm passwords match." },
          { title: "Update your profile", desc: "Keep your rank, sea service and details current so recruiters and institutes see accurate information." },
          { title: "Manage your email", desc: "Your email is your sign-in ID. If you've lost access to it, contact us and we'll verify and update it securely." },
          { title: "Deactivate account", desc: "Need to step away? Email us from your registered address and we'll help you deactivate or delete your account." },
        ],
      },
      {
        id: "support",
        icon: "ShieldCheck",
        heading: "Support — Jobs, Courses & Safety",
        intro:
          "For help with jobs, courses, institutes, or to report suspicious activity, our support team is on it. Write to support@indosbook.com.",
        contactEmail: "support@indosbook.com",
        contactNote: "For jobs, courses, fraud reporting & disputes",
        cards: [
          { title: "Jobs & applications", desc: "Questions about a vacancy, applying, or hearing back from a company? We'll help you track it down." },
          { title: "Courses & admissions", desc: "Issues with course listings, batch dates or admissions at an institute? We'll connect you with the right team." },
          { title: "Report fraud", desc: "See a fake vacancy, a recruiter asking for payment, or any suspicious activity? Report it immediately — your report keeps the community safe." },
          { title: "Company / institute issues", desc: "Trouble with your organisation's profile, verification badge, or posting access? We'll sort it out." },
          { title: "Billing & disputes", desc: "Questions about payments or a disagreement with another member? Reach out and we'll mediate fairly." },
          { title: "Something else", desc: "Can't find your issue here? Just email us — we reply to every genuine query." },
        ],
      },
    ],
  },

  network: {
    slug: "network",
    seoTitle: "Network & Connect with Seafarers | Indosbook",
    seoDescription:
      "Connect with seafarers, shipping companies and maritime institutes on Indosbook. Add crewmates, join communities by rank and vessel type, and message recruiters directly.",
    eyebrow: "Network & Connect",
    title: "Your crew, your companies, one network",
    subtitle:
      "Find old shipmates, follow the fleets you want to sail with and join communities built around your rank, vessel type and voyage — all in one place.",
    sections: [
      {
        id: "connect",
        icon: "Users",
        heading: "Connect with Crewmates",
        intro: "Build a network of officers, engineers and ratings you've sailed with — and the ones you'll sail with next.",
        cards: [
          { title: "Add friends", desc: "Search by name or rank and send a friend request to seafarers you know from past contracts." },
          { title: "Follow companies", desc: "Follow shipping companies and manning agencies to see their vacancies and updates first in your feed." },
          { title: "Share your voyage", desc: "Post photos, voyage cards and sea stories so your network knows where you're sailing." },
        ],
      },
      {
        id: "communities",
        icon: "Handshake",
        heading: "Join Maritime Communities",
        intro: "Communities bring together seafarers who share a rank, a vessel type or a goal — like clearing your next COC.",
        cards: [
          { title: "By rank", desc: "Deck officers, engineers, ETOs and ratings each have spaces to swap advice and experience." },
          { title: "By vessel type", desc: "Tanker, bulk, container, LNG, offshore and cruise crews share real, practical knowledge." },
          { title: "Start your own", desc: "Create a community for your batch, your academy or your fleet and invite others to join." },
        ],
      },
    ],
  },

  jobs: {
    slug: "jobs",
    seoTitle: "Genuine Merchant Navy Jobs — No Agent Fees | Indosbook",
    seoDescription:
      "Apply to genuine ship jobs posted directly by RPSL-licensed manning agencies and shipping companies. Filter by rank and vessel type. Indosbook never charges seafarers for jobs.",
    eyebrow: "Genuine Jobs",
    title: "Real vacancies from real fleets",
    subtitle:
      "Every job on Indosbook is posted directly by a shipping company or licensed manning agency — so you apply to the people actually hiring, without middlemen or fees.",
    sections: [
      {
        id: "direct",
        icon: "Briefcase",
        heading: "Direct From Companies",
        intro: "Companies and RPSL-licensed recruiters post vacancies themselves, with rank, vessel type, wages and joining dates.",
        cards: [
          { title: "Apply in one tap", desc: "Your profile, sea service and certificates go straight to the recruiter — no forms to fill again." },
          { title: "Track your applications", desc: "See every job you've applied to and its status from your Indosbook feed." },
          { title: "Match your rank", desc: "See vacancies that fit your rank and vessel experience first." },
        ],
      },
      {
        id: "safe",
        icon: "ShieldCheck",
        heading: "Safe & Free for Seafarers",
        intro: "Applying for jobs on Indosbook is always free. A genuine employer will never ask you to pay for a job.",
        cards: [
          { title: "No placement fees", desc: "Indosbook never charges seafarers to apply. Never pay anyone who promises you a job." },
          { title: "Checked postings", desc: "Suspicious vacancies are reviewed and removed, and repeat offenders are banned." },
          { title: "Report anything odd", desc: "See a fake job or a fee request? Report it and our team will act quickly." },
        ],
      },
    ],
  },

  "verified-crew": {
    slug: "verified-crew",
    seoTitle: "Verified Crew Profiles for Seafarers | Indosbook",
    seoDescription:
      "Build a verified seafarer profile on Indosbook with your rank, sea service record and certificate vault (COC, CDC, STCW). Get expiry alerts and stand out to shipping recruiters.",
    eyebrow: "Verified Crew Profiles",
    title: "A profile recruiters can trust",
    subtitle:
      "Your rank, sea service and certificates in one place — so shipping companies see a complete, credible picture of your career at a glance.",
    sections: [
      {
        id: "profile",
        icon: "BadgeCheck",
        heading: "Your Seafarer Profile",
        intro: "A complete profile earns a green Complete Profile badge on every post you share.",
        cards: [
          { title: "Sea service record", desc: "Log every vessel, rank, sign-on and sign-off date to show your real experience." },
          { title: "Rank & vessel types", desc: "Show recruiters exactly what you sail and what you're ready for next." },
          { title: "Profile photo", desc: "A clear photo helps crewmates and recruiters recognise you." },
        ],
      },
      {
        id: "vault",
        icon: "BookOpen",
        heading: "Certificate Vault & Expiry Alerts",
        intro: "Keep COC, CDC, passport and STCW certificates safe and never miss a renewal.",
        cards: [
          { title: "Secure storage", desc: "Upload your certificates once and share them with recruiters when you apply." },
          { title: "Expiry alerts", desc: "Get reminders 60, 30 and 7 days before any document expires." },
          { title: "Always ready", desc: "Your documents are ready the moment a good vacancy comes up." },
        ],
      },
    ],
  },

  "report-fraud": {
    slug: "report-fraud",
    seoTitle: "Report Fraud & Fake Ship Jobs | Indosbook",
    seoDescription:
      "Report fake merchant navy jobs, recruiters asking for money or suspicious profiles on Indosbook. Email support@indosbook.com — every report is reviewed to keep seafarers safe.",
    eyebrow: "Report Fraud",
    title: "Help us keep the sea safe",
    subtitle:
      "Fake vacancies and fee scams hurt seafarers and their families. If something doesn't look right, tell us — we review every report.",
    sections: [
      {
        id: "report",
        icon: "AlertTriangle",
        heading: "How to Report",
        intro: "Email us with the profile name, job link or screenshots and a short description of what happened.",
        contactEmail: "support@indosbook.com",
        contactNote: "Report fake jobs, fee requests or suspicious profiles",
        cards: [
          { title: "Fake job post", desc: "A vacancy with unrealistic wages, no company details or pressure to decide fast." },
          { title: "Money requests", desc: "Anyone asking for a fee, deposit or 'processing charge' to give you a job." },
          { title: "Fake profiles", desc: "Accounts pretending to be a company, institute or crewmate you know." },
        ],
      },
      {
        id: "stay-safe",
        icon: "ShieldCheck",
        heading: "Stay Safe",
        intro: "A few simple habits protect you from most recruitment scams.",
        cards: [
          { title: "Never pay for a job", desc: "Genuine companies and RPSL agencies never charge seafarers for placement." },
          { title: "Check the company", desc: "Look for the company's verified page and its RPSL licence before sharing documents." },
          { title: "Keep documents private", desc: "Share your certificates only through Indosbook applications or with verified recruiters." },
        ],
      },
    ],
  },
};

// Footer columns link into the grouped content pages (always open from top)
export const footerColumns = [
  {
    h: "Why Indosbook",
    items: [
      { label: "Network & Connect", to: "/pages/network" },
      { label: "Genuine Jobs", to: "/pages/jobs" },
      { label: "Verified Crew Profiles", to: "/pages/verified-crew" },
    ],
  },
  {
    h: "Community",
    items: [
      { label: "Communities", to: "/pages/community" },
      { label: "Guidelines", to: "/pages/community" },
      { label: "Feed", to: "/feed" },
    ],
  },
  {
    h: "Careers",
    items: [
      { label: "Companies", to: "/pages/careers" },
      { label: "Find jobs", to: "/pages/careers" },
      { label: "Post a job", to: "/pages/careers" },
    ],
  },
  {
    h: "Institutes",
    items: [
      { label: "Courses", to: "/pages/institutes" },
      { label: "Admissions", to: "/pages/institutes" },
      { label: "Partner with us", to: "/pages/institutes" },
    ],
  },
  {
    h: "Help & Support",
    items: [
      { label: "Help Center", to: "/pages/help" },
      { label: "Support", to: "/pages/help" },
      { label: "Report fraud", to: "/pages/report-fraud" },
    ],
  },
];
